import { ILoadingBox } from "./LoadingBox.interfaces"
import { StyledSkeleton } from "./LoadingBox.styled"

const LoadingBox = ({ width, height, variant, noAnimate }: ILoadingBox) => {
  return (
    <StyledSkeleton
      animation={noAnimate ? false : "wave"}
      variant={variant ? variant : "rectangular"}
      width={width ? width : "40px"}
      height={height ? height : "40px"}></StyledSkeleton>
  )
}

export default LoadingBox
